<template>
    <v-app>
        <div class="loading" v-if="loading.show">
            <div class="loading-inner">
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
            </div>
        </div>

        <v-toolbar app class="app-toolbar">
            <v-btn :ripple="false" icon @click="$router.go(-1)">
                <v-icon class="icon-light">arrow_back</v-icon>
            </v-btn>
            <v-toolbar-title>Symptom Checker</v-toolbar-title>
        </v-toolbar>
        <v-content pa-0>
            <v-container fluid fill-height pa-0>
                <v-layout>
                    <v-flex xs12>
                        <v-stepper v-model="step" fill-height>
                            <v-stepper-header>
                                <v-stepper-step :complete="step > 1" step="1">
                                    Details
                                    <small>where does it hurt?</small>
                                </v-stepper-step>

                                <v-divider></v-divider>

                                <v-stepper-step :complete="step > 2" step="2">
                                    Possible Symptoms
                                    <small>pick a symptom</small>
                                </v-stepper-step>

                                <v-divider></v-divider>

                                <v-stepper-step step="3" :complete="step > 3">
                                    Additional Symptoms
                                    <small>do you have any of these too?</small>
                                </v-stepper-step>
                                <v-divider></v-divider>

                                <v-stepper-step step="4" :complete="step > 4">
                                    Diseases
                                    <small>possible causes</small>
                                </v-stepper-step>
                                <v-divider></v-divider>
                                <v-stepper-step step="5">
                                    Description
                                    <small>about the disease</small>
                                </v-stepper-step>
                            </v-stepper-header>
                            <v-stepper-items fill-height>
                                <v-stepper-content step="1">
                                    <vas-symptom-1/>

                                    <v-footer app>
                                        <v-spacer></v-spacer>
                                        <v-btn color="primary" flat small @click="executeStep1()" :disabled="!step1Ready" class="text-xs-right">
                                            Next
                                            <v-icon>chevron_right</v-icon>
                                        </v-btn>
                                    </v-footer>
                                </v-stepper-content>

                                <v-stepper-content step="2">
                                    <vas-symptom-2 v-if="symptom.availableSymptoms != null"/>

                                    <v-footer app>
                                        <v-btn color="primary" flat small @click="step = 1" class="text-xs-right">
                                            <v-icon>chevron_left</v-icon>
                                            Back
                                        </v-btn>
                                        <v-spacer></v-spacer>
                                    </v-footer>
                                </v-stepper-content>

                                <v-stepper-content step="3">
                                    <vas-symptom-3 v-if="symptom.selectedSymptom != null"/>

                                    <v-footer app>
                                        <v-btn color="primary" flat small @click="step3Back()" class="text-xs-right">
                                            <v-icon>chevron_left</v-icon>
                                            Back
                                        </v-btn>
                                        <v-spacer></v-spacer>
                                        <v-btn color="primary" flat small @click="executeStep3()" class="text-xs-right">
                                            Next
                                            <v-icon>chevron_right</v-icon>
                                        </v-btn>
                                    </v-footer>
                                </v-stepper-content>
                                <v-stepper-content step="4">
                                    <vas-symptom-4 v-if="symptom.availableDiagnosis != null"/>

                                    <v-footer app>
                                        <v-btn color="primary" flat small @click="step = 3" class="text-xs-right">
                                            <v-icon>chevron_left</v-icon>
                                            Back
                                        </v-btn>
                                        <v-spacer></v-spacer>
                                    </v-footer>
                                </v-stepper-content>
                                <v-stepper-content step="5">
                                    <vas-symptom-5 v-if="symptom.loadedDisease != null"/>

                                    <v-footer app>
                                        <v-btn color="primary" flat small @click="step = 4" class="text-xs-right">
                                            <v-icon>chevron_left</v-icon>
                                            Back
                                        </v-btn>
                                        <v-spacer></v-spacer>
                                        <v-btn color="primary" flat small @click="restart" class="text-xs-right">
                                            Restart
                                            <v-icon>refresh</v-icon>
                                        </v-btn>
                                    </v-footer>
                                </v-stepper-content>
                            </v-stepper-items>
                        </v-stepper>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-content>
    </v-app>
</template>
<script>
    import priaid from '@/lib/priaid/Client'
    import {mapState, mapActions} from 'vuex'

    export default {
        data() {
            return {
                step: 1,
                loading: {
                    show: false
                }
            }
        },
        computed: {
            ...mapState(
                ['symptom', 'auth']
            ),
            nextEnabled() {
                if (this.step === 1) {
                    if (this.selectedGender != null && this.selectedYear != null && this.selectedPart != null && this.selectedSubPart != null) {
                        return true;
                    }
                }

                return false;
            },
            nextVisible() {
                if (this.step === 1) {
                    return true;
                }

                return false;
            },
            previousVisible() {
                return false;
            },
            step1Ready() {
                if (this.symptom.selectedGender == null) {
                    return false;
                }
                if (this.symptom.selectedYear == null) {
                    return false;
                }
                if (this.symptom.selectedPart == null) {
                    return false;
                }
                if (this.symptom.selectedSubPart == null) {
                    return false;
                }

                return true;
            }
        },
        mounted() {
            this.initEvents();
            this.restart();
            this.$store.dispatch('symptom/reset');
        },
        methods: {
            initEvents() {
                var self = this;

                EventBus.$on('symptom-symptom-selected', item => {
                    this.$store.commit('symptom/setSelectedSymptom', item)

                    Loading.show('')

                    self.loadProposedSymptoms();

                    Loading.show('')
                });

                EventBus.$on('symptom-additional-symptom-selected', item => {
                    Loading.show('');

                    var tmp = self.symptom.selectedAdditionalSymptoms;

                    var remove = -1;
                    for (var i in tmp) {
                        if (tmp[i].ID == item.ID) {
                            remove = i;

                            break;
                        }
                    }

                    if (remove >= 0) {
                        tmp.splice(remove, 1);
                    } else {
                        tmp.push(item);
                    }

                    self.symptom.selectedAdditionalSymptoms = tmp;

                    self.loadProposedSymptoms();
                });

                EventBus.$on('symptom-diagnosis-selected', item => {
                    self.symptom.selectedDisease = item;
                    self.loadDisease();
                });
            },
            restart() {
                this.$store.dispatch('symptom/reset');

                var year = null;
                if (this.auth.user.age != null && this.auth.user.age > 0) {
                    year = new Date().getYear() - this.auth.user.age;
                }

                this.$store.commit('symptom/setSelectedGender', this.auth.user.sex);
                this.$store.commit('symptom/setSelectedYear', year);
                this.$store.commit('symptom/setSelectedPart', null);
                this.$store.commit('symptom/setSelectedSubPart', null);
                this.$store.commit('symptom/setAvailableSymptoms', null);
                this.$store.commit('symptom/setAdditionalSymptoms', null);
                this.$store.commit('symptom/setSelectedSymptom', null);
                this.$store.commit('symptom/setSelectedAdditionalSymptoms', null);
                this.$store.commit('symptom/setAvailableDiagnosis', null);
                this.$store.commit('symptom/setSelectedDisease', null);
                this.$store.commit('symptom/setLoadedDisease', null);

                // this.symptom.selectedGender = null;
                // this.symptom.selectedYear = null;

                this.step = 1;
            },
            next() {

            },
            previous() {

            },
            executeStep1() {
                this.$store.commit('symptom/setAvailableSymptoms', null);
                this.$store.commit('symptom/setAdditionalSymptoms', null);
                this.$store.commit('symptom/setSelectedSymptom', null);
                this.$store.commit('symptom/setSelectedAdditionalSymptoms', null);
                this.$store.commit('symptom/setAvailableDiagnosis', null);
                this.$store.commit('symptom/setSelectedDisease', null);
                this.$store.commit('symptom/setLoadedDisease', null);

                this.loadInitialSymptoms();
            },
            executeStep3() {
                this.loadDiagnosis();
            },
            step3Back() {
                this.step = 2;
                this.$store.commit('symptom/setSelectedAdditionalSymptoms', null);
            },
            loadInitialSymptoms() {
                this.$store.commit('symptom/setAvailableSymptoms', null);
                this.$store.commit('symptom/setAdditionalSymptoms', null);
                this.$store.commit('symptom/setSelectedSymptom', null);
                this.$store.commit('symptom/setSelectedAdditionalSymptoms', null);
                this.$store.commit('symptom/setAvailableDiagnosis', null);
                this.$store.commit('symptom/setSelectedDisease', null);
                this.$store.commit('symptom/setLoadedDisease', null);

                var self = this;

                Loading.show('');

                priaid.loadInitialSymptoms(this.symptom.selectedSubPart.ID, this.symptom.selectedGender == 'Male' ? 'Man' : 'Woman').then(function (result) {
                    result.sort(function (a, b) {
                        if (a.Name > b.Name) {
                            return 1;
                        }

                        if (a.Name < b.Name) {
                            return -1;
                        }

                        return 0;
                    });

                    self.symptom.availableSymptoms = result;

                    self.step = 2;

                    Loading.hide()
                });
            },
            loadProposedSymptoms() {
                Loading.show('');
                this.loading.show = true;

                var self = this;

                var symptoms = [self.symptom.selectedSymptom.ID];
                for (var i in self.symptom.selectedAdditionalSymptoms) {
                    symptoms.push(self.symptom.selectedAdditionalSymptoms[i].ID);
                }
                Loading.show('')
                priaid.loadProposedSymptoms(symptoms, this.symptom.selectedGender, self.symptom.selectedYear)
                    .then(function (result) {
                            self.symptom.additionalSymptoms = result;

                            self.step = 3;

                            Loading.hide()

                            self.loading.show = false;
                        }
                    );
            },
            loadDiagnosis() {
                console.log("Loading diagnosis")

                var self = this;

                var symptoms = [self.symptom.selectedSymptom.ID];
                for (var i in self.symptom.selectedAdditionalSymptoms) {
                    symptoms.push(self.symptom.selectedAdditionalSymptoms[i].ID);
                }

                Loading.show('');

                priaid.loadDiagnosis(symptoms, this.symptom.selectedGender, self.symptom.selectedYear).then(function (result) {
                    self.symptom.availableDiagnosis = result;

                    self.step = 4;

                    Loading.hide()
                });
            },
            loadDisease() {
                console.log("Loading desease")

                var self = this;
                Loading.show('');
                priaid.loadIssueInfo(self.symptom.selectedDisease.Issue.ID).then(function (result) {
                    self.symptom.loadedDisease = result;

                    self.step = 5;

                    Loading.hide()
                });
            }
        }
    }
</script>
<style>
    .v-stepper, .v-stepper__items, .v-stepper__content {
        height: 100%
    }

    .v-stepper__content {
        /*overflow: scroll;*/
    }

    .v-stepper__header {
        background: #fff;
        position: fixed;
        width: 100vw;
        z-index: 99;
    }

    .v-stepper__items {
        margin-top: 72px;
    }

    .theme--light.v-stepper {
        background: transparent;
    }

    .theme--light.v-list {
        background: transparent;
    }

    .v-stepper__content {
        padding: 0;
    }
</style>
